import { FC } from 'react';

import headerButtonClick from '@hh.ru/analytics-js-events/build/career_platform/common/header_button_click';
import { useSelector } from '@hh.ru/front-static-app';
import { SPALink } from '@hh.ru/redux-spa-middleware';

import { INDEX_ROUTE, LK_ROUTE } from 'src/app/routesUtils';
import useFeatureEnabled from 'src/hooks/useFeatureEnabled';

import Logo from 'src/components/Header/HeaderLogo/assets/logo.svg';
import LogoTitle from 'src/components/Header/HeaderLogo/assets/logoTitle.svg';

import styles from './styles.less';

const Features = {
    isEnabledLK: 'enabled_lk',
};

const handleClick = () => {
    headerButtonClick({
        buttonName: 'logo',
    });
};

const HeaderLogo: FC = () => {
    const isAuth = useSelector((state) => !!state.profile);
    const isEnabledLK = useFeatureEnabled(Features.isEnabledLK);

    return (
        <SPALink
            className={styles.container}
            to={isAuth && isEnabledLK ? LK_ROUTE : INDEX_ROUTE}
            isSeoLink
            onClick={handleClick}
        >
            <Logo className={styles.hhLogo} />
            <div className={styles.title}>
                <LogoTitle className={styles.logoAppTitleMob} />
            </div>
        </SPALink>
    );
};

export default HeaderLogo;
